import React from 'react';
import styles from './style.module.scss';

interface LoadingScreenProps {
  textMain: string;
  textSecondary?: string;
  displaySpinner?: boolean;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ textMain, textSecondary, displaySpinner }) => (

  <div className={styles.loadingContainer}>
    {displaySpinner && <div className={styles.spinner}></div>}
    <p className={styles.text}>{textMain}</p>
    {textSecondary && <p className={styles['text-secondary']}>{textSecondary}</p>}
  </div>

);
